import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'

import { Route } from 'react-router-dom'
import Topbar from '../Topbar/'

class EditProfileComponet extends Component {
  constructor() {
    super();

  }


  render() {
    return (
      <div>
      </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
})

const EditProfile = connect(mapStateToProps, {

})(EditProfileComponet)

export default EditProfile


// WEBPACK FOOTER //
// ./src/Components/EditProfile/index.js